// extracted by mini-css-extract-plugin
module.exports = {"sociometryResultItemInfo":"SociometryResultItemInfo_sociometryResultItemInfo__1z-Sx","title":"SociometryResultItemInfo_title__2uCxA"};